// removed by extract-text-webpack-plugin
module.exports = {"baseHighlight":"_2Lw9","content":"_3gp2","title":"_3LEU","text":"_1FRt","link":"_1WsL","highlight":"UAL6 _2Lw9","moreHighlight":"_2rad _2Lw9","section-title":"_3vyR","time":"_1zTu"};


//////////////////
// WEBPACK FOOTER
// ./src/components/DropdownHighlight/DropdownHighlight.styl
// module id = 75
// module chunks = 0